export default "__VITE_ASSET__B3I0c$3a__"